import React from 'react';
import { Table, Tag } from 'antd';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import { checkValue, truncateString } from 'utils';
import { priceRender, renderWithTooltip } from 'utils/table';
import { SumRange } from 'components/Filters/SumRange';
import { InputFilter } from 'components/Filters/InputFilter';
import { CheckboxFilter } from 'components/Filters/CheckboxFilter';
import { FilterIcon } from 'components/Filters/FilterIcon';

function ProductServicesTable({
  items,
  filters = {},
  current,
  pageSize,
  loading,
  onRowClick,
  total,
  onChange,
  onFilter,
}) {
  const { name, type, f_price, t_price } = filters;

  const columns = [
    {
      title: 'Наименование',
      dataIndex: 'name',
      key: 'name',
      render: (value) => renderWithTooltip(value),
      filterDropdown: () => (
        <InputFilter
          value={name}
          placeholder="Поиск по наименованию"
          onFilterChange={(name) => onFilter({ name })}
        />
      ),
      filterIcon: () => <FilterIcon search isActive={name} />,
    },
    {
      title: 'Цена (₸)',
      dataIndex: 'rate',
      key: 'rate',
      render: priceRender,
      filterDropdown: () => {
        return (
          <SumRange
            fromValue={f_price}
            toValue={t_price}
            getRange={(first, second) =>
              onFilter({ f_price: first, t_price: second })
            }
          />
        );
      },
      filterIcon: () => <FilterIcon isActive={f_price || t_price} />,
    },
    {
      title: 'Тип',
      dataIndex: 'type',
      key: 'type',
      render: (type) => {
        const types = {
          product: 'Товар',
          service: 'Услуга',
        };

        const colors = {
          product: 'cyan',
          service: 'purple',
        };

        return <Tag color={colors[type]}>{types[type]}</Tag>;
      },
      filterDropdown: () => (
        <CheckboxFilter
          filter={type}
          filters={[
            { text: 'Услуга', value: 'service' },
            { text: 'Товар', value: 'product' },
          ]}
          onFilterChange={(type) => onFilter({ type })}
        />
      ),
      filterIcon: () => <FilterIcon isActive={type} />,
    },
    {
      title: 'Единица',
      dataIndex: 'measure',
      key: 'measure',
      render: (measure) => (measure ? truncateString(measure, 20) : '---'),
    },
    {
      title: 'Штрих код',
      dataIndex: 'barcode',
      key: 'barcode',
      render: checkValue,
    },
    {
      title: 'Источник',
      dataIndex: 'origin',
      key: 'origin',
    },
    {
      title: 'Клиент',
      dataIndex: 'company_name',
      key: 'company_name',
      render: (name) => renderWithTooltip(name),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      scroll={{ y: SCROLL_Y, x: '1200px' }}
      pagination={{
        total,
        current,
        pageSize,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
        showSizeChanger: true,
      }}
      rowKey="id"
      tableLayout="fixed"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { ProductServicesTable };
